import { render, staticRenderFns } from "./ModalNickname.vue?vue&type=template&id=2edc8be5&scoped=true"
import script from "./ModalNickname.vue?vue&type=script&lang=js"
export * from "./ModalNickname.vue?vue&type=script&lang=js"
import style0 from "./ModalNickname.vue?vue&type=style&index=0&id=2edc8be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc8be5",
  null
  
)

export default component.exports